// btw-front/src/components/ui/Badge.jsx
import React from "react";

// 영업단계 7종 톤 — 진행 흐름에 따라 회색 → 청록(진행) → 초록(도입) / 빨강(실주).
// 가입 신청 상태(pending/approved/rejected) 와 일부 톤 재사용.
const TONE = {
  brochure_sent: "border-slate-200 bg-slate-100 text-slate-700",
  intro: "border-sky-200 bg-sky-50 text-sky-700",
  prelim_quote: "border-cyan-200 bg-cyan-50 text-cyan-700",
  poc: "border-violet-200 bg-violet-50 text-violet-700",
  proposal: "border-indigo-200 bg-indigo-50 text-indigo-700",
  adoption: "border-emerald-200 bg-emerald-50 text-emerald-700",
  lost: "border-rose-200 bg-rose-50 text-rose-700",
  pending: "border-amber-200 bg-amber-50 text-amber-700",
  approved: "border-emerald-200 bg-emerald-50 text-emerald-700",
  rejected: "border-rose-200 bg-rose-50 text-rose-700",
  neutral: "border-slate-200 bg-white text-slate-600",
  review: "border-slate-200 bg-slate-100 text-slate-700",
  done: "border-blue-200 bg-blue-50 text-blue-700",
  draft: "border-amber-200 bg-amber-50 text-amber-700",
  published: "border-emerald-200 bg-emerald-50 text-emerald-700",
};

export function Badge({ tone = "neutral", className = "", children }) {
  const cls = TONE[tone] || TONE.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium ${cls} ${className}`}
    >
      {children}
    </span>
  );
}
